"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const WarningSystemIcon = props => {
  const {
      size = 24
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "WARNING-SYSTEM-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M12 0c.975 0 1.864.555 2.294 1.43l9.473 19.297A2.271 2.271 0 0 1 21.728 24H2.272a2.271 2.271 0 0 1-2.04-3.272L9.707 1.429A2.556 2.556 0 0 1 12 0Zm0 1.5c-.403 0-.77.23-.948.59L1.58 21.39a.771.771 0 0 0 .693 1.111h19.456a.771.771 0 0 0 .693-1.112L12.948 2.091A1.056 1.056 0 0 0 12 1.5M12 18a1.125 1.125 0 1 1 0 2.25A1.125 1.125 0 0 1 12 18Zm0-10.5a.75.75 0 0 1 .75.75v7.5a.75.75 0 1 1-1.5 0v-7.5A.75.75 0 0 1 12 7.5"
  })));
};
WarningSystemIcon.displayName = "WarningSystemIcon";
WarningSystemIcon.iconName = "Warning";
export default WarningSystemIcon;